
export const convertTimeToMinutesString = (time: number) => {
  return {
    1: '5m',
    2: '15m',
    3: '30m',
    4: '1h',
    5: '2h+'
  }[time] || '?m';
}

export const convertEnergyToString = (energy: number): string => {
  return {
    1: 'Effortless',
    2: 'Low',
    3: 'Some',
    4: 'Normal',
    5: 'High'
  }[energy] || '?';
}

export const convertPriorityToString = (priority: number): string => {
  return {
    1: 'Optional',
    2: 'Low',
    3: 'Medium',
    4: 'High',
    5: 'Critical'
  }[priority] || '?';
}